import type { AnalyticsProperties, ClientAnalyticsEvent } from '@/features/analytics/events';
import { supabase } from '@/lib/supabaseClient';

/**
 * Продуктовые события с клиента.
 *
 * Аналитика не имеет права влиять на сценарий: упавшая вставка события не
 * ломает создание портрета и ничего не показывает человеку. Событий о
 * фактах сервера здесь нет — их пишет сервер, и политика базы клиенту их
 * не позволит (см. миграцию analytics).
 */
export async function recordAnalyticsEvent(
  event: ClientAnalyticsEvent,
  properties: AnalyticsProperties = {},
): Promise<void> {
  if (!supabase) {
    return;
  }

  try {
    const { data } = await supabase.auth.getSession();
    const userId = data.session?.user.id;

    // Без сессии событие некому приписать: RLS всё равно откажет, а
    // «событие без владельца» испортило бы отчёт молча.
    if (!userId) {
      return;
    }

    await supabase.from('analytics_events').insert({
      user_id: userId,
      event,
      source: 'client',
      properties,
    });
  } catch {
    // Тишина здесь намеренная: человек пришёл за портретом, а не за
    // сообщением о том, что не записалась статистика.
  }
}

/** Отправить событие и не ждать: вызывающему сценарию ответ не нужен. */
export function track(event: ClientAnalyticsEvent, properties?: AnalyticsProperties): void {
  void recordAnalyticsEvent(event, properties);
}
